import ApiService from "../../services/ApiService";
import translate from "../../services/Translate";

export const statuses = [
  "SUCCESS",
  "REPASS",
  "FAILED",
  "CORRECTION_PENDING",
  "BEING_CORRECTED",
  "PRE_CORRECTION_IN_PROGRESS",
  "PRE_CORRECTED",
  "IN_PROGRESS",
  "CREATED",
];

export const languages = ["fr-FR", "en-US"];

export const format = ["HTML", "NOTEBOOK", "UPLOAD", "MONITORED_UPLOAD"];

export const fetchPoles = (setPoles: Function, language: string, setLoading: Function) => {
  setLoading(true);
  ApiService.get("poles")
    .then((response) => setPoles(response.data.poles))
    .catch((error) => {
      console.error("Error fetching poles:", error);
      alert(translate(language, "ERROR.API_ERROR"));
    })
    .finally(() => setLoading(false));
};

export const fetchPrograms = (setPrograms: Function, language: string, setLoading: Function) => {
  setLoading(true);
  ApiService.get("programs?order_by=name&order=asc")
    .then((response) => setPrograms(response.data.programs))
    .catch((error) => {
      console.error("Error fetching programs:", error);
      alert(translate(language, "ERROR.API_ERROR"));
    })
    .finally(() => setLoading(false));
};

export const fetchFlags = (setFlags: Function, language: string, setLoading: Function) => {
  setLoading(true);
  ApiService.get("flags")
    .then((response) => setFlags(response.data.flags))
    .catch((error) => {
      console.error("Error fetching flags:", error);
      alert(translate(language, "ERROR.API_ERROR"));
    })
    .finally(() => setLoading(false));
};
